import { LISTING_STATUS_CODE } from "../../../components/common/const";

export default {
  serverError: {
    confrim: "Confirm",
    defaultTitle: "Error",
    commonMessage:
      "Sorry. An unexpected error has occurred. Please try again later.",
    500: {
      title: "Sorry. An unexpected error has occurred.",
      content:
        "We're working on the issue and we'll be up and running again shortly. Please try again later.",
    },
    general: {
      title: "Hey!",
      content: "Something went wrong. Please try again later.",
    },
    publishError: {
      default: {
        title: `There was an issue whilst you were trying to {status, plural, =${LISTING_STATUS_CODE.DRAFT} {publish} =${LISTING_STATUS_CODE.ONLINE} {upgrade} other {reactive}} your listing.`,
        content: `The changes you have made are saved. Try to {status, plural, =${LISTING_STATUS_CODE.DRAFT} {publish} =${LISTING_STATUS_CODE.ONLINE} {upgrade} other {reactive}} this listing again. [{code}]`,
      },
      field: {
        title: "You still have required fields to complete to publish",
        content: `Step {stepNumber} - {stepName}: {fieldName}`,
      },
      QUOTE_IS_USED: {
        title: "You do not have enough upgrades or listings to continue.",
        content: "Please review your selection before proceeding.",
      },
      QUOTE_NOT_FOUND: {
        title: "You do not have enough upgrades or listings to continue.",
        content: "Please review your selection before proceeding.",
      },
    },
    UPGRADE_LISTING_FAILED_ACTIVE_SCHEDULER: {
      title: "Listing could not be upgraded",
      content:
        "Since this listing is scheduled to readvertise, it cannot be upgraded.",
    },
    DOWNGRADE_LISTING_FAILED_ACTIVE_SCHEDULER: {
      title: "Listing could not be downgraded",
      content:
        "Since this listing is scheduled to readvertise, it cannot be downgraded.",
    },
    OFFLINE_LISTING_FAILED_ACTIVE_SCHEDULER: {
      title: "Listing could not be taken offline",
      content:
        "Since this listing is scheduled to readvertise, it cannot be taken offline.",
    },
    RS_LISTING_REJECT_EXPIRY_DATE: {
      title: "Listing expiring before scheduled readvertise date",
      content:
        "We could not schedule readvertisement for this listing since it will expire before it is readvertised. Please select a date before the listing expiry.",
    },
    RS_MAXIMUM_QUEUE_LIMIT: {
      title: "Scheduled readvertisements limit reached",
      content:
        "Cannot be readvertised as you've reached the max limit of 5000 scheduled readvertisements.",
    },
    RS_NOT_ENOUGH_CREDIT: {
      content: `Not enough credits to readvertise this listing.Please get in touch with your account manager to top up.`,
    },
    VIOLATED_UPGRADE_STATE: {
      content:
        "Sorry. An unexpected error has occurred. Please make sure the listings is not being edited by other users.",
    },
    RS_LISTING_REJECT_DEGRADED: {
      title: "This listing has been flagged",
      content: "Please contact your Account Manager to find out more.",
    },
    VIOLATED_UPGRADE_STATE_DEGRADE_FLAG: {
      content:
        "This listing has been flagged. Please contact your Account Manager to find out more.",
    },
    VIOLATED_READVERTISE_DEGRADE_FLAG: {
      content:
        "This listing has been flagged. Please contact your Account Manager to find out more.",
    },
    VIOLATED_DOWNGRADE_STATE: {
      content:
        "Sorry. An unexpected error has occurred. Please make sure the listings is not being edited by other users.",
    },
    VIOLATED_DOWNGRADE_RULE: {
      content:
        "Sorry. An unexpected error has occurred. Please make sure the listings is not being edited by other users.",
    },
    PERMISSION_DENY_DOWNGRADE_LISTING: {
      content: "You don't have permission to downgrade this listing.",
    },
    PERMISSION_DENY_VIEW_USER: {
      content: "You do not have permission to view this listing. ",
    },
    PERMISSION_DENY_UPDATE_LISTING: {
      content: "You do not have permission to create a listing. ",
    },
    PERMISSION_DENY_HIERARCHY: {
      content: "You do not have permission to this organization.",
    },
    PERMISSION_DENY_EXTEND_LISTING: {
      title: "this listing cannot be extended",
      content:
        "Sorry. An unexpected error has occurred. Please make sure the listings is not being edited by other users.",
    },
    DOWNGRATE_LISTING_FAILED: {
      content: "We could not downgrade your listing. Please try again later.",
    },
    DELETE_LISTING_FAILED: {
      content: "We could not delete your listing. Please try again later.",
    },
    OFFLINE_LISTING_FAILED: {
      content:
        "We could not take your listing offline. Please try again later.",
    },
    UPDATED_FAILED: {
      content: "We could not publish your listing. Please try again later.",
    },
    NOT_ALLOW_TO_EDIT_CAR_PARK: {
      content:
        "Only can edit car park in draft listing (unless the previous data is empty)",
    },
    NOT_ALLOW_TO_EDIT_UNIT: {
      content:
        "Only can edit unit in draft listing (unless the previous data is empty)",
    },
    NOT_ALLOW_TO_EDIT_FLOOR: {
      content:
        "Only can edit floor in draft listing (unless the previous data is empty)",
    },
    NOT_ALLOW_TO_EDIT_POSTAL_CODE: {
      content: "Not allowed to edit postal code",
    },
    NOT_ALLOW_TO_EDIT_ADDRESS: {
      content: "Only can edit address in draft listing",
    },
    NOT_ALLOW_TO_EDIT_LOCATION_LEVEL1: {
      content: "Only can edit location level 1 in draft listing",
    },
    NOT_ALLOW_TO_EDIT_LOCATION_LEVEL2: {
      content: "Only can edit location level 2 in draft listing",
    },
    NOT_ALLOW_TO_EDIT_LOCATION_LEVEL3: {
      content: "Only can edit location level 3 in draft listing",
    },
    NOT_ALLOW_TO_EDIT_LOCATION_LEVEL5: {
      content: "Only can edit location level 5 in draft listing",
    },
    NOT_ALLOW_TO_EDIT_PROPERTY_TYPE: {
      content: "Only can edit property type in draft listing",
    },
    NOT_ALLOW_TO_EDIT_CHANNEL_CODE: {
      content: "Only can edit channel in draft listing",
    },
    INVALID_CHANNEL_CODE: {
      content: "Please select a listing type.",
    },
    INVALID_SORT_BY: {
      content: "Something went wrong. Try refreshing the page and try again.",
    },
    INVALID_SALEABLE_AREA: {
      content: "Must be more than 0.",
    },
    INVALID_SALE_PRICE: {
      content: "Must be more than 0.",
    },
    INVALID_RENT_PRICE: {
      content: "Must be more than 0.",
    },
    INVALID_GROSS_AREA: {
      content: "Must be more than 0.",
    },
    INVALID_OUTDOOR_AREA: {
      content: "Must be more than 0.",
    },
    INVALID_VIDEO_URL: {
      content: "Youtube URL is invalid. Please try again.",
    },
    INVALID_TOUR_VIDEO_URL: {
      content: "Tour Video URL is invalid. Please try again.",
    },
    INVALID_IMAGE_PATH: {
      content: "Image URL is invalid. Please try again.",
    },
    INVALID_PROPERTY_TYPE_CODE: {
      content: "Property Type code is invalid. Please try again.",
    },
    INVALID_BATHROOM: {
      content: "Must be between 0 and 99.",
    },
    INVALID_LAYOUT_CODE: {
      content: "Layout code is invalid. Please try again.",
    },
    INVALID_FLOOR_ZONE_CODE: {
      content: "Floor Zone code is invalid. Please try again. ",
    },
    INVALID_VIEW_CODE: {
      content: "View code is invalid. Please try again.",
    },
    INVALID_DIRECTION_CODE: {
      content: "Direction code is invalid. Please try again",
    },
    INVALID_CONDITION_CODE: {
      content: "Condition code is invalid. Please try again.",
    },
    INVALID_UNIT_FEATURED_CODE: {
      content: "Unit featured code is invalid. Please try again.",
    },
    INVALID_BUILDING_FACILITY_CODE: {
      content: "Building facility code is invalid. Please try again.",
    },
    INVALID_IMAGE_TYPE_CODE: {
      content: "Image type code is invalid. Please try again.",
    },
    INVALID_RICH_MEDIA_TYPE_CODE: {
      content: "Rich media type code is invalid. Please try again.",
    },
    INVALID_LOCATION_REFERENCE: {
      content: "Location reference is invalid. Level 1, 2 and 3 must match. ",
    },
    INVALID_QUOTE: {
      content:
        "Something went wrong. We saved your changes. Try refreshing the page and publish it again.",
    },
    INVALID_LISTER_ID: {
      content: "The Lister ID is invalid. Please try again. ",
    },
    INVALID_LISTER_ID_FOR_AGENT_CONTRACT: {
      content:
        "We couldn't publish your listing.The Agent ID in your contract does not match your Lister ID. Go to Step 1 and remove the primary agent or select another contract.",
    },
    INVALID_STOREY_CODE: {
      content: "Storey code is invalid. Please try again.",
    },
    BUILDING_REQUEST_FAILED: {
      content: "Building could not be found. ",
    },
    BUILDING_REQUEST_LEVEL_2_NOT_FOUND: {
      content: "Level 2 of this building could not be found.",
    },
    INVALID_SALEABLE_AREA_MEASUREMENT_CODE: {
      content: "Saleable/Built-up area code is invalid. Please try again.",
    },
    INVALID_GROSS_AREA_MEASUREMENT_CODE: {
      content: "Invalid Gross/Land area code is invalid. Please try again.",
    },
    CHANNEL_TYPE_MANDATORY: {
      content: "Please select a channel type.",
    },
    PROPERTY_TYPE_MANDATORY: {
      content: "Please select a property type.",
    },
    SALEABLE_AREA_MANDATORY: {
      content: "Saleable area is required.",
    },
    GROSS_AREA_MANDATORY: {
      content: "Gross area is required.",
    },
    SALEABLE_AREA_VERIFIED_MANDATORY: {
      content: "Step 3-Property Details: Is this saleable area verified?",
    },
    LOCATION_MANDATORY: {
      content: "Location is required.",
    },
    LOCATION_LEVEL_3_ID_MANDATORY: {
      content: "Location level 3 ID field is mandatory",
    },
    LOCATION_LEVEL_2_ID_MANDATORY: {
      content: "Location level 2 ID field is mandatory",
    },
    LOCATION_LEVEL_1_ID_MANDATORY: {
      content: "Location level 1 ID field is mandatory",
    },
    LOCATION_LEVEL_5_NANOID_MANDATORY: {
      content: "Location level 5 NANOID field is mandatory",
    },
    LOCATION_LEVEL_3_NANOID_MANDATORY: {
      content: "Location level 3 NANOID field is mandatory",
    },
    LOCATION_LEVEL_2_NANOID_MANDATORY: {
      content: "Location level 2 NANOID field is mandatory",
    },
    LOCATION_LEVEL_1_NANOID_MANDATORY: {
      content: "Location level 1 NANOID field is mandatory",
    },
    LOCATION_ADDRESS_MANDATORY: {
      content: "Address is required.",
    },
    PHOTO_MANDATORY: {
      content: "Photo image is required. Please upload at least one photo.",
    },
    PROPERTY_NO_MANDATORY: {
      content: "EAA Property Number is required.",
    },
    BATHROOM_MANDATORY: {
      content: "Number of bathrooms is required.",
    },
    LOCATION_LEVEL_1_MANDATORY: {
      content: "District is required.",
    },
    LOCATION_LEVEL_2_MANDATORY: {
      content: "Estate is required.",
    },
    LOCATION_LEVEL_4_MANDATORY: {
      content: "Street is required.",
    },
    LOCATION_LEVEL_5_MANDATORY: {
      content: "Project name / block field is required.",
    },
    GROSS_AREA_DIMENSION_WIDTH_MANDATORY: {
      content: "Width is required.",
    },
    GROSS_AREA_DIMENSION_LENGTH_MANDATORY: {
      content: "Length is required.",
    },
    SALEABLE_AREA_DIMENSION_WIDTH_MANDATORY: {
      content: "Width is required.",
    },
    SALEABLE_AREA_DIMENSION_LENGTH_MANDATORY: {
      content: "Length is required.",
    },
    TITLE_TYPE_CODE_MANDATORY: {
      content: "Please select title type.",
    },
    LAND_TITLE_TYPE_CODE_MANDATORY: {
      content: "Please select land title type.",
    },
    AUCTION_DATE_MANDATORY: {
      content: "Auction date is required.",
    },
    PROPERTY_CATEGORY_TYPE_CODE_MANDATORY: {
      content: "Please select a category.",
    },
    PROPERTY_GROUP_TYPE_CODE_MANDATORY: {
      content: "Please select a group type.",
    },
    STOREY_CODE_MANDATORY: {
      content: "Storey is required.",
    },
    MEASUREMENT_CODE_MANDATORY: {
      content: "Measurement is required.",
    },
    CARPARK_MANDATORY: {
      content: "Number of carpark is required.",
    },
    TENURE_CODE_MANDATORY: {
      content: "Please select one tenure type.",
    },
    INVALID_LOCATION_POSTAL_CODE: {
      content: "Postal code is invalid.",
    },
    PREMIUM_MINIMUM_PHOTO_MANDATORY: {
      content: "Premium listings requires more than 5 photos to proceed.",
    },
    LOCATION_LEVEL_5_ID_MANDATORY: {
      content: "Level 5 location building name / commercial lot is required.",
    },
    STANDARD_QUOTE_MANDATORY: {
      content: "Standard quote is required.",
    },
    INSUFFICIENT_QUOTE: {
      content: "Insufficient credit.",
    },
    GROSS_AREA_MEASUREMENT_CODE_MANDATORY: {
      content: "Gross and land area is required.",
    },
    SALEABLE_AREA_MEASUREMENT_CODE_MANDATORY: {
      content: "Saleable and built up area is required.",
    },
    LISTING_REF_NO_EXCEED_MAX_LENGTH: {
      content: "Maximum of 15 characters.",
    },
    LOCATION_ADDRESS_EXCEED_MAX_LENGTH: {
      content: "Maximum of 100 characters.",
    },
    LOCATION_UNIT_EXCEED_MAX_LENGTH: {
      content: "Maximum of 15 characters.",
    },
    LOCATION_FLOOR_EXCEED_MAX_LENGTH: {
      content: "Maximum of 15 characters.",
    },
    SALE_PRICE_EXCEED_MAX_LENGTH: {
      content: "Maximum of 15 characters.",
    },
    RENT_PRICE_EXCEED_MAX_LENGTH: {
      content: "Maximum of 15 characters.",
    },
    SALEABLE_AREA_EXCEED_MAX_LENGTH: {
      content: "Maximum of 9 digits.",
    },
    GROSS_AREA_EXCEED_MAX_LENGTH: {
      content: "Maximum of 9 digits.",
    },
    OUTDOOR_AREA_EXCEED_MAX_LENGTH: {
      content: "Maximum of 9 digits.",
    },
    BEDROOM_EXCEED_MAX_LENGTH: {
      content: "Maximum of 2 digits.",
    },
    BATHROOM_EXCEED_MAX_LENGTH: {
      content: "Maximum of 2 digits.",
    },
    PHOTO_EXCEED_MAX_LIMIT: {
      content: "You've reached the maximum limit of 40 photos.",
    },
    FLOORPLAN_EXCEED_MAX_LIMIT: {
      content: "You've reached the maximum limit of 5 floor plans.",
    },
    LOCATION_LEVEL3_TEXT_EXCEED_MAX_LENGTH: {
      content: "Please limit your input to 50 characters.",
    },
    LOCATION_LEVEL5_TEXT_EXCEED_MAX_LENGTH: {
      content: "Maximum of 5 digits.",
    },
    LOCATION_POSTAL_CODE_EXCEED_MAX_LENGTH: {
      content: "Postal code is invalid. Please try again.",
    },
    LOCATION_BLOCK_EXCEED_MAX_LENGTH: {
      content: "Postal code is invalid. Please try again.",
    },
    UNEXPIRED_LEASE_YEAR_EXCEED_MAX_LENGTH: {
      title: "Please check unexpired lease year",
      content:
        "In your location, the unexpired lease year should not be more than 2 digits. Please re-enter valid years to continue.",
    },
    SALE_PRICE_MANDATORY: {
      title: "Please check sale price",
      content:
        "Sale price is always mandatory. Please re-enter valid price to continue.",
    },
    RENT_PRICE_MANDATORY: {
      title: "Please check rent price",
      content:
        "Rent price is always mandatory. Please re-enter valid price to continue.",
    },
    PERMISSION_DENY_UPGRADE_LISTING: {
      content: "You do not have access to action on the listing.",
    },
    PERMISSION_DENY_DELETE_LISTING: {
      content: "You do not have access to action on the listing.",
    },
    PERMISSION_DENY_OFFLINE_LISTING: {
      content: "You do not have access to action on the listing.",
    },
    PERMISSION_DENY_PUBLISH_LISTING: {
      content: "You do not have access to action on the listing.",
    },
    NETWORK_ERROR: {
      content:
        "Sorry. An unexpected error has occurred. We’re working on the issue and we’ll be up and running again shortly. Please try again later.",
    },
    VIOLATED_DELETE_STATE: {
      content:
        "Sorry. An unexpected error has occurred. Please make sure the listings is not being edited by other users.",
    },
    VIOLATED_OFFLINE_STATE: {
      content:
        "Sorry. An unexpected error has occurred. Please make sure the listings is not being edited by other users.",
    },
    VIOLATED_PUBLISH_STATE: {
      content:
        "Sorry. An unexpected error has occurred. Please make sure the listings is not being edited by other users.",
    },
    VIOLATED_PUBLISH: {
      content:
        "Sorry. An unexpected error has occurred. Please make sure the listings is not being edited by other users.",
    },
    VIOLATED_UPGRADE: {
      content:
        "Sorry. An unexpected error has occurred. Please make sure the listings is not being edited by other users.",
    },
    VIOLATED_UPGRADE_RULE: {
      content:
        "Sorry. An unexpected error has occurred. Please make sure the listings is not being edited by other users.",
    },
    INVALID_BEDROOM: {
      content:
        "Please fill all required fields to publish. Step 3: Number of Bedrooms",
    },
    QUOTE_NOT_FOUND: {
      content:
        "Sorry. An unexpected error has occurred. Please try again later or contact customer service.",
    },
    PURCHASE_FAILED: {
      content:
        "Sorry. An unexpected error has occurred. Please try again later.",
    },
    NO_SUBSCRIPTION: {
      content:
        "Sorry. An unexpected error has occurred. Please try again later or contact customer service.",
    },
    QUOTE_EXPIRED: {
      content:
        "Sorry. An unexpected error has occurred. Please try again later or contact customer service.",
    },
    TITLE_MANDATORY: {
      content: "Please insert a Headline, it's a mandatory field.",
    },
    TITLE_NOT_ENOUGH_MIN_LENGTH: {
      content: "Please create a Headline that has 10 characters or more.",
    },
    TITLE_EXCEED_MAX_LENGTH: {
      content: "The headline may not be greater than 70 characters.",
    },
    TITLE_INVALID_CHARACTER: {
      content:
        "Listing headline may only contain letters, numbers and basic punctuation.",
    },
    TITLE_FIRST_LETTER_NOT_CAPITALIZED: {
      content:
        "The first word in each sentence must begin with a capital letter.",
    },
    TITLE_HAS_PHONE: {
      content: "Number with 7 digits or more is not allowed.",
    },
    DESCRIPTION_HAS_PHONE: {
      content: "Number with 6 digits or more is not allowed.",
    },
    DESCRIPTION_INVALID_CHARACTER: {
      content:
        "Listing description may only contain letters, numbers and basic punctuation.",
    },
    TITLE_TOO_MANY_PUNCTUATION: {
      content: "Please keep to a maximum of 2 punctuation marks consecutively.",
    },
    TITLE_INVALID_CAPITALIZED: {
      content:
        "Except standard abbreviations like 'MRT' and 'LRT', please only have the first letter of words be capitalized.",
    },
    TITLE_CONTAINS_RACIST_WORD: {
      content:
        "Race related or other unacceptable words detected. Remove the words to continue.",
    },
    DESCRIPTION_CONTAINS_RACIST_WORD: {
      content:
        "Race related or other unacceptable words detected. Remove the words to continue.",
    },
    DESCRIPTION_EXCEED_MAX_LENGTH: {
      content: "The description may not be greater than {max} characters.",
    },
    LEVEL3_TEXT_CONTAINS_BLACKLIST_WORD: {
      content: "Please enter only the township name.",
    },
    LEVEL3_TEXT_CONTAINS_REPEATED_WORD: {
      content: "You do not need to repeat the township name twice.",
    },
  },
};
